module.exports = __webpack_public_path__ + "static/media/Tuto_acceder_a_la_visio_BBB_prof.485a3bbd.pdf";